// import { Modal } from '@mui/material';
// import MyButton from 'components/Button.tsx';
// import React, { useState } from 'react';
// import { Language } from 'shared/Language';

// const PopupSucess = (props) => {
//     const {open, iconHead, title, des, setOpenModal} = props;
//     return (
//         <Modal open={open}>
//             <div id="popup-print">
//                 <div className="popup-print-container">
//                     <img src="assets/icon/Success/index.svg" alt="success" />
//                     <div className="success-text">{Language.payment.popupPayment.paymentSuccess}</div>
//                     <div className="detail-text"><div className="voucher-text">Voucher decreased</div> <div className="value-text">-2,620,000 đ</div></div>
//                     <MyButton label={Language.common.confirm} styleContainer={'btn-pay'} onPress={setOpenModal(false)}/>
//                 </div>
//             </div>
//         </Modal>
//     );
// };
// export default PopupSucess;


import { Modal } from '@mui/material';
import MyButton from 'components/Button.tsx';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Language } from 'shared/Language';
import Box from '@mui/material/Box';
import './styles.scss';
const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};

type ModalProps = {
    onConfirm: () => any;
}

export type ModalAction = {
    showModal?: (value) => any;
    hideModal?: () => any;
}
const PopupUnpaidOrder = forwardRef<ModalAction, ModalProps>(({ onConfirm }: ModalProps, ref) => {
    const [open, setOpen] = useState<boolean>(false);
    const [title, setTitle] = useState<string>('');
    const showModal = value => {
        setOpen(true);
        setTitle(value);
    };

    const hideModal = () => {
        setOpen(false);
    };

    const onPressConfirm = () => {
        onConfirm?.();
        hideModal();
    };

    useImperativeHandle(ref, () => ({
        showModal,
        hideModal
    }));

    return (
        <Modal open={open} onBackdropClick={onPressConfirm}>
            <Box sx={style}>
                <div className='popup-unpaid'>
                    <div className="popup-failed">
                        <div className="text-big-x bold color-black mgb-16">
                            Payment failed
                        </div>
                        <div className="text-normal bold color-black mgb-16">
                            {title || 'Order trên đã thanh toán. Bạn không được phép lưu.'}
                        </div>
                        <MyButton label={Language.common.close} styleContainer={'btn-success'} onPress={onPressConfirm} />
                    </div>
                </div>
            </Box>
        </Modal>
    );
});
export default PopupUnpaidOrder;

